import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { GisNhipMapComponent } from 'src/app/main/shared/gis-nhip-map/gis-nhip-map.component';
import { UtilsService } from 'src/app/utils/utils.service';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-nhip-home-sidebar',
  templateUrl: './nhip-home-sidebar.component.html',
  styleUrls: ['./nhip-home-sidebar.component.scss']
})
export class NhipHomeSidebarComponent implements OnInit, AfterViewInit {
  isInitialLoad: boolean = false;
  queryParams: any;
  activeHazard: string | null = null;

  selectedOption: { [key: string]: string[] | string } = {
    earthquake: [],
    cyclone: [],
    timerange: 'Last 10 Years'
  };

  defaultSelections = {
    earthquake: ['Zones', 'Fault Lines', 'Magnitude'],
    cyclone: ['Wind Zone', 'Cyclone Line', 'Cyclone Point']
  };

  multiHazardSelections = {
    earthquake: ['Magnitude', 'Fault Lines'],
    cyclone: ['Cyclone Point', 'Cyclone Line']
  }

  masterHazardConfig = [
    {
      key: 'earthquake',
      label: 'Earthquakes',
      options: ['Fault Lines', 'Magnitude', 'Zones'],
      toggle: false,
      selectAll: true
    },
    {
      key: 'cyclone',
      label: 'Cyclones',
      options: ['Wind Zone', 'Cyclone Line', 'Cyclone Point'],
      toggle: false,
      selectAll: true
    },
    // {
    //   key: 'windspeed',
    //   label: 'Wind Speed',
    //   icon: 'bi bi-speedometer2',
    //   options: ['Low', 'Medium', 'High'],
    //   toggle: false
    // },
    {
      key: 'timerange',
      label: 'Time Range',
      options: ['Last 10 Years', 'Last 20 years', 'All Historical'],
      toggle: false
    },
    {
      key: 'location',
      label: 'Location Info',
      options: ['View Location Map'],
      toggle: false,
      isNavigation: true
    },
  ];

    multiHazardConfig = [
    {
      key: 'earthquake',
      label: 'Earthquakes',
      options: ['Fault Lines', 'Magnitude'],
      toggle: false,
      selectAll: true
    },
    {
      key: 'cyclone',
      label: 'Cyclones',
      options: ['Cyclone Line', 'Cyclone Point'],
      toggle: false,
      selectAll: true
    },
    // {
    //   key: 'windspeed',
    //   label: 'Wind Speed',
    //   icon: 'bi bi-speedometer2',
    //   options: ['Low', 'Medium', 'High'],
    //   toggle: false
    // },
    {
      key: 'timerange',
      label: 'Time Range',
      options: ['Last 10 Years', 'Last 20 years', 'All Historical'],
      toggle: false
    },
    // {
    //   key: 'location',
    //   label: 'Location Info',
    //   options: ['View Location Map'],
    //   toggle: false,
    //   isNavigation: true
    // },
  ];

  hazardConfig = [];
  selectedHazard: string | null = null;
  hazardOptions:any = {'multiHazard' : 'Multi Hazard', cyclone : 'Cyclone', earthquake : 'Earthquake'}
  hazardView:any = 'multiHazard'

  constructor(
    public gisUtils: UtilsService,
    private router: Router,
    private route: ActivatedRoute,
    private gisMapComp: GisNhipMapComponent
  ) { }

  ngOnInit() {
    this.route.queryParamMap.subscribe((params: Params) => {
      this.queryParams = {};
      for (const param in params) {
        if (params.hasOwnProperty(param)) {
          this.queryParams = params[param];
        }
      }
      // if (this.queryParams && this.queryParams['mode'] === 'location-only') {
      //   setTimeout(() => {
      //     this.gisMapComp.loadLocationOnlyMap();
      //   }, 500);
      //   return;
      // }

      if (!isNullOrUndefined(this.queryParams) && Object.keys(this.queryParams).length > 0 && this.selectedHazard != this.queryParams.hazardView) {
        this.selectedHazard = this.queryParams.hazardView
        this.hazardView = this.selectedHazard
        this.isInitialLoad = true
        this.requestSelectedFilterParams();
        this.updateHazardConfig()
        setTimeout(() => {
          this.renderHazardLayers()
        }, 500)
      }
    });

    // Subscribe to legend close button clicks
    this.gisUtils.nhipLayerToggle.subscribe((layerName: string) => {
      if (layerName) {
        // Find which hazard category this layer belongs to
        const earthquakeOptions = ['Fault Lines', 'Magnitude', 'Zones'];
        const cycloneOptions = ['Wind Zone', 'Cyclone Line', 'Cyclone Point'];

        if (earthquakeOptions.includes(layerName)) {
          this.selectOption('earthquake', layerName);
        } else if (cycloneOptions.includes(layerName)) {
          this.selectOption('cyclone', layerName);
        }
      }
    });
  }

  ngAfterViewInit() {
    // if (this.queryParams && this.queryParams['mode'] === 'location-only') {
    //   return;
    // }
    // Initialize default layers after view is ready
    setTimeout(() => {
      // this.renderHazardLayers()
    }, 500);
  }

  updateHazardConfig() {
    if (this.selectedHazard === 'earthquake') {
      this.hazardConfig = this.masterHazardConfig.filter(
        item => item.key === 'earthquake' || item.key === 'timerange'
      );
      this.selectedOption.earthquake = [...this.defaultSelections.earthquake];
      this.selectedOption.cyclone = [];

    }
    else if (this.selectedHazard === 'cyclone') {
      this.hazardConfig = this.masterHazardConfig.filter(
        item => item.key === 'cyclone' || item.key === 'timerange'
      );
      this.selectedOption.earthquake = [];
      this.selectedOption.cyclone = [...this.defaultSelections.cyclone];

    }
    else if (this.selectedHazard === 'multiHazard') {
      this.hazardConfig = [...this.multiHazardConfig];
      this.selectedOption.earthquake = [...this.multiHazardSelections.earthquake];
      this.selectedOption.cyclone = [...this.multiHazardSelections.cyclone];

    }
  }

  renderHazardLayers() {
    const mergedOptions: string[] = this.masterHazardConfig.reduce(
      (acc: string[], hazard) => acc.concat(hazard.options),
      []
    );
    const currentSelected: string[] = [];
    if (this.selectedHazard == 'earthquake') {
      if (Array.isArray(this.selectedOption['earthquake'])) {
        currentSelected.push(...this.selectedOption['earthquake']);
      }
    } else if (this.selectedHazard == 'cyclone') {
      if (Array.isArray(this.selectedOption['cyclone'])) {
        currentSelected.push(...this.selectedOption['cyclone']);
      }
    } else {
      if (Array.isArray(this.selectedOption['earthquake'])) {
        currentSelected.push(...this.selectedOption['earthquake']);
      }
      if (Array.isArray(this.selectedOption['cyclone'])) {
        currentSelected.push(...this.selectedOption['cyclone']);
      }
    }    
    this.gisMapComp.timerange = this.selectedOption['timerange']
    this.gisMapComp.injectedService['handleHazardLayers'](
      this.gisMapComp,
      currentSelected.length > 0 ? currentSelected : ['Zones', 'Fault Lines'],
      this.queryParams,
      mergedOptions
    );
  }

  requestSelectedFilterParams() {
    let currentUrlParams: any = {};
    currentUrlParams['component'] = 'NHIP';
    currentUrlParams['src'] = 'IMD_GRID';
    if (this.isInitialLoad) {
      currentUrlParams['actionType'] = 'filter';
      currentUrlParams['view'] = 'ADMIN';
      currentUrlParams['pType'] = 'COUNTRY';
      currentUrlParams['cType'] = 'STATE';
      currentUrlParams['parentLoc'] = 'COUNTRY';
      currentUrlParams['dashboardView'] = 'INDIA';
      this.gisUtils.selectedParams.next(currentUrlParams);
      this.isInitialLoad = false;
    }
  }

  // In NhipHomeSidebarComponent
  navigateToLocationMap(event: Event) {
    event.stopPropagation();

    // this.router.navigate([], {
    //   relativeTo: this.route,
    //   queryParams: {
    //     locationOnly: 'true',
    //     locType: 'COUNTRY',
    //     locName: 'India',
    //     pUUID: '00cb31c7-2928-4e6d-adcc-443d478c90d6',
    //     location: 'India##00cb31c7-2928-4e6d-adcc-443d478c90d6',
    //     t: new Date().getTime()
    //   },
    //   queryParamsHandling: 'merge'
    // });

    // Close dropdown
    this.activeHazard = null;
    const locationHazard = this.hazardConfig.find(h => h.key === 'location');
    if (locationHazard) locationHazard.toggle = false;
    this.hazardView = 'locationInfo'
    this.onHazardChange()
  }

  toggleSelectAll(hazard: any) {
    if (hazard.key === 'timerange' || hazard.key === 'location') return;
    hazard.selectAll = !hazard.selectAll;
    if (hazard.selectAll) {
      this.selectedOption[hazard.key] = [...hazard.options];
    } else {
      this.selectedOption[hazard.key] = [];
    }

    this.updateMapLayers();
  }

  selectOption(hazardKey: string, option: string) {
    const hazard = this.hazardConfig.find(h => h.key === hazardKey);
    if (!hazard) return;

    if (hazardKey === 'timerange') {
      this.selectedOption[hazardKey] = option;
      this.gisUtils.nhipTimeRangeChange.next(option);
      this.updateMapLayers();
      return;
    }
    if (hazardKey === 'location') {
      return;
    }
    if (!Array.isArray(this.selectedOption[hazardKey])) {
      this.selectedOption[hazardKey] = [];
    }

    const selectedArray = this.selectedOption[hazardKey] as string[];
    const index = selectedArray.indexOf(option);

    if (index > -1) {
      selectedArray.splice(index, 1);
    } else {
      selectedArray.push(option);
    }
    hazard.selectAll = selectedArray.length === hazard.options.length;
    this.updateMapLayers();
  }

  toggleHazard(hazard: any) {
    this.activeHazard = this.activeHazard === hazard.key ? null : hazard.key;
    hazard.toggle = !hazard.toggle;
  }

  private updateMapLayers() {
    const mergedOptions: string[] = this.masterHazardConfig.reduce(
      (acc: string[], h) => acc.concat(h.options),
      []
    );
    const allSelected: string[] = [];
    if (Array.isArray(this.selectedOption['earthquake'])) {
      allSelected.push(...this.selectedOption['earthquake']);
    }
    if (Array.isArray(this.selectedOption['cyclone'])) {
      allSelected.push(...this.selectedOption['cyclone']);
    }
    this.gisMapComp.timerange = this.selectedOption['timerange']
    this.gisMapComp.injectedService['handleHazardLayers'](
      this.gisMapComp,
      allSelected,
      this.queryParams,
      mergedOptions
    );
  }
  isOptionSelected(hazardKey: string, option: string): boolean {
    if (hazardKey === 'timerange') {
      return this.selectedOption[hazardKey] === option;
    }
    if (hazardKey === 'location') {
      return false;
    }

    if (Array.isArray(this.selectedOption[hazardKey])) {
      return (this.selectedOption[hazardKey] as string[]).includes(option);
    }

    return false;
  }

  onHazardChange() {
    let options = {... this.queryParams }
    options['hazardView'] = this.hazardView
    // this.gisMapComp.params['actionType'] = 'filter'
    this.router.navigate(['.'],{
      relativeTo: this.route,
      queryParams: options,
      queryParamsHandling: 'merge'
    })
  }

  logout() {
    this.router.navigate(['nhip-dashboard'])
  }
}
